import { ISEOWaterObj } from './constants';

/*
  This is hardcoded SEO data
  It was handpicked by the SEO expert and reflects the most searched for fishing locations in the US.
  In the future this should be stored and fetched from the backend.
  ATTENTION: These links wont work on staging db because the fishingWaterIds are different there.
*/
export const TOP_SEARCHED_WATERS: ISEOWaterObj[] = [
  {
    locationName: 'Lake Erie',
    // region is not shown on purpose
    fishingWaterId: 'WBqNgCU9',
  },
  {
    locationName: 'Sebastian Inlet',
    region: 'Fl',
    fishingWaterId: 'LJ1yfTpG',
  },
  {
    locationName: 'Salmon River',
    region: 'NY',
    fishingWaterId: 'OuDf9dlW',
  },
  {
    locationName: 'Devils Lake',
    region: 'ND',
    fishingWaterId: 'W1TvBELQ',
  },
  {
    locationName: 'Rocky River',
    region: 'OH',
    fishingWaterId: '8uhvbQOy',
  },
  {
    locationName: 'Lake Hartwell',
    region: 'GA',
    fishingWaterId: 'Is9FiGjO',
  },
  {
    locationName: 'Lake Guntersville',
    region: 'AL',
    fishingWaterId: 'YnXpKnOW',
  },
  {
    locationName: 'Lake Lanier',
    region: 'GA',
    fishingWaterId: '5KS8EmQ1',
  },
  {
    locationName: 'Leech Lake',
    region: 'MN',
    fishingWaterId: '4SWs6xYf',
  },
  {
    locationName: 'Lake Texoma',
    // region is not shown on purpose
    fishingWaterId: '4SJGXFwf',
  },
  {
    locationName: 'Lake Fork',
    region: 'TX',
    fishingWaterId: 'QoUxdW31',
  },
  {
    locationName: 'Red Lake',
    region: 'WA',
    fishingWaterId: 'GRVdGyQN',
  },
  {
    locationName: 'Bighorn River',
    region: 'MT',
    fishingWaterId: 'k0Zi3VB8',
  },
  {
    locationName: 'Lake Conroe',
    region: 'TX',
    fishingWaterId: 'KdxV3urx',
  },
  {
    locationName: 'Cape Cod',
    region: 'MA',
    fishingWaterId: 'jmmrQ7l6',
  },
];
